<template>
  <popup-dialog :title="title" @close="close" v-if="visible">
    <div class="html-desc" v-html="content"></div>
  </popup-dialog>
</template>

<script>
import PopupDialog from "@/components/popupDialog";
export default {
  name: "serviceAgreement",
  components: {
    PopupDialog
  },
  data() {
    return {
      title: "",
      content: "",
      visible: false,
    }
  },
  methods: {
    open(name, e) {
      this.title = name;
      this.content = e;
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .popup-wrap {
    position: relative;
    width: 800px !important;
    .html-desc {
      margin-top: 30px;
      height: 600px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        background: #999;
        border-radius: 8px;
        position: absolute;
        right: 0;
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  ::v-deep {
    .popup-wrap {
      width: 90% !important;
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  ::v-deep {
    .popup-wrap {
      width: 90% !important;
    }
  }
}
</style>